// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, shallowEqual } from 'react-redux';
import path from 'ramda/es/path';

import Loading from 'app/common/components/Loader';
import { OpenFilterButton } from 'app/common/ui-next/plain-button';
import RowLayout, { Header } from 'app/common/layouts/RowLayout';
import { PlainInputSearch } from 'app/common/ui/PlainInput';
import useSearch from 'app/common/hooks/useSearch';
import ControlsBar from 'app/common/ui-next/controls-bar';

import OrdersList from './OrdersList';
import OrdersData from '../OrdersData';
import Filters from './Filters';
import useFilters from './useFilters';


type Props = {
  deliveryPointUuid?: string,
}

const Orders = ({
  deliveryPointUuid,
}: Props) => {
  const { t } = useTranslation('shop');
  const userUuid = useSelector(state => state.user.shop.user_id, shallowEqual);

  const [
    [filterShow, handelToggleFilter],
    [filterState, handelChangeFilter],
    [isFilterDefaultState, handleResetFilter],
  ] = useFilters();

  const shippingStatus = path(['shippingStatus', 0], filterState);
  const paymentStatus = path(['paymentStatus', 0], filterState);
  const [searchString, handleSearch, handleClearSearch] = useSearch();

  return (
    <React.Fragment>
      <RowLayout>
        <Header>{t('orders_header')}</Header>
      </RowLayout>

      <RowLayout flex>
        <ControlsBar>
          {/* Кнопка открытия фильтров */}
          <OpenFilterButton
            checked={!isFilterDefaultState}
            opened={filterShow}
            onClick={handelToggleFilter}
          />

          {/* Форма поиска */}
          <PlainInputSearch
            searchString={searchString}
            handleSearch={handleSearch}
            handleClearSearch={handleClearSearch}
          />
        </ControlsBar>
      </RowLayout>

      {/* Выпадающее окно с фильтрами */}
      {filterShow
        && <Filters
          filterState={filterState}
          onChange={handelChangeFilter}
          onCloseClick={handelToggleFilter}
          onReset={handleResetFilter}
        />}
      {userUuid && deliveryPointUuid
        ? <OrdersData
          userUuid={userUuid}
          deliveryPointUuid={deliveryPointUuid}
          search={searchString}
          shippingStatus={shippingStatus}
          paymentStatus={paymentStatus}
        >
          <OrdersList />
        </OrdersData>
        : <Loading />}
    </React.Fragment>
  );
};

export default Orders;
